export default __webpack_public_path__ + "static/media/Loader.31b840aa.svg";